import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { HomePage } from './pages/HomePage'
import { PlaySession } from './pages/PlaySession'
import { PuzzleCreator } from './pages/PuzzleCreator'
import { EditPuzzle } from './pages/EditPuzzle'
import { AdminDashboard } from './pages/AdminDashboard'
import { ReportManagementPage } from './pages/ReportManagementPage'
import { ExplanationReviewPage } from './pages/ExplanationReviewPage'
import { SessionListPage } from './pages/SessionListPage'
import { MissingCluesPage } from './pages/MissingCluesPage'
import { BatchExplanationsPage } from './pages/BatchExplanationsPage'
import { EditPuzzleClues } from './pages/EditPuzzleClues'
import { WordplayDemoPage } from './pages/WordplayDemoPage'
import { ParsewordsTestPage } from './pages/ParsewordsTestPage'
import { ParsewordsAdminPage } from './pages/ParsewordsAdminPage'
import { AuthModal } from './components/AuthModal'
import { NavBar } from './components/NavBar'
import { useViewportCssVars } from './utils/useViewportCssVars'

function App() {
  useViewportCssVars()

  return (
    <BrowserRouter>
      <NavBar />
      <AuthModal />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/sessions" element={<SessionListPage />} />
        <Route path="/admin/reports" element={<ReportManagementPage />} />
        <Route path="/admin/missing-clues" element={<MissingCluesPage />} />
        <Route path="/admin/batch-explanations" element={<BatchExplanationsPage />} />
        <Route path="/admin/clues/:puzzleId" element={<EditPuzzleClues />} />
        <Route path="/admin/puzzles/:id/explanations" element={<ExplanationReviewPage />} />
        <Route path="/create" element={<PuzzleCreator />} />
        <Route path="/edit/:puzzleId" element={<EditPuzzle />} />

        <Route path="/wordplay-demo" element={<WordplayDemoPage />} />
        <Route path="/parsewords-test" element={<ParsewordsTestPage />} />
        <Route path="/admin/parsewords" element={<ParsewordsAdminPage />} />

        {/* Gameplay Routes - Use GameConnectionProvider (SSE) internally */}
        <Route path="/play/:sessionId" element={<PlaySession />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
